import React from 'react'
import Siema from 'siema'

class Slider extends React.Component {
  constructor(props) {
    super(props)
    this.parentRef = React.createRef()
    this.change = this.change.bind(this)
    this.state = { currentSlide: 0 }
  }

  componentDidMount() {
    this.siema = new Siema({
      selector: this.parentRef.current,
      onChange: this.change,
    })
  }

  componentWillUnmount() {
    this.siema.destroy()
  }

  change() {
    this.setState({ currentSlide: this.siema.currentSlide })
  }

  render() {
    return (
      <div css={{ position: 'relative' }}>
        <div ref={this.parentRef}>
          {this.props.children.map((child, index) => (
            <div key={index}>
              {child}
            </div>
          ))}
        </div>
        <ul
          css={{
            bottom: 0,
            left: '50%',
            listStyle: 'none',
            margin: 10,
            padding: 0,
            position: 'absolute',
            transform: 'translateX(-50%)',
          }}
        >
          {this.props.children.length > 1 ? this.props.children.map((child, index) => (
            <li
              key={index}
              css={{
                backgroundColor: this.state.currentSlide === index ? '#fff' : 'rgba(255, 255, 255, .5)',
                borderRadius: '50%',
                boxShadow: '0 1px 2px rgba(0, 0, 0, .1)',
                display: 'inline-block',
                height: 6,
                margin: '0 5px 0 0',
                width: 6,
              }}
            />
          )) : ''}
        </ul>
      </div>
    )
  }
}

export default Slider


// WEBPACK FOOTER //
// ./src/components/Slider.js